import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout, Button, Typography, Form, Input, Image, Card } from "antd";

import logo2 from "../../img/brand/brand.png";

import utils from "../dependencies/custom/react-utilities";
import Settings from "../dependencies/custom/settings";
import ValueStores from "../store/values-store";
import Utilities from "../dependencies/custom/react-utilities";
import useWindowDimensions from "../hooks/screensize";

const { Title } = Typography;
const { Header, Footer, Content } = Layout;

export default function SignIn() {
  const valuesStore = ValueStores();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { vpWidth, vpHeight } = useWindowDimensions();
  const isMobile = vpWidth <= 768;

  const onFinish = async (values) => {
    const activeLock = Utilities.getSessionLock();
    if (activeLock?.userId) {
      Utilities.showNotification(
        "Active Session",
        "Another user is already logged in on this browser. Please log out from the other session first.",
        "text-warning",
      );
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const res = await utils.fetchWithAuth(
        "POST",
        Settings.urls.auth.login,
        values,
        navigate,
      );
      if (res?.ok) {
        valuesStore.resetAuthState?.();
        const enable2FA = parseInt(res?.data?.["2FA"]);
        const signupOtpActivated = res?.data?.user?.signupOtpActivated;
        if (enable2FA || !signupOtpActivated) {
          navigate("../../otp", {
            state: { user: res?.data?.user, admissions: res?.data?.admissions },
          });
        } else {
          Utilities.setCookie("access", res?.data?.access);
          Utilities.setCookie("refresh", res?.data?.refresh);
          valuesStore.setValue("user", res?.data?.user);
          valuesStore.setValue("admissions", res?.data?.admissions);
          sessionStorage.setItem("user", JSON.stringify(res?.data?.user));
          sessionStorage.setItem(
            "admissions",
            JSON.stringify(res?.data?.admissions),
          );
          Utilities.setSessionLock(res?.data?.user?.id, {
            user: res?.data?.user,
            admissions: res?.data?.admissions,
          });
          navigate("../../welcome/me", {
            state: { user: res?.data?.user, admissions: res?.data?.admissions },
          });
        }
      } else {
        Utilities.showError(res, "Unable to sign in");
      }
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Layout className="layout-default ant-layout layout-sign-up">
        <Content className="p-0">
          <div
            className="sign-up-header mt-5x"
            style={{
              // backgroundImage: `url(${banner2})`,
              background: isMobile
                ? "transparent"
                : "linear-gradient(to right, #1f1f5d, #3a7bd5)",
              height: "300px",
              border: isMobile && "none",
              boxShadow: isMobile && "none",
            }}
          />
          <Card
            className="card-signup header-solid h-full ant-card pt-0"
            title={
              <div className="d-flexx justify-content-centerx">
                <div className="d-flex justify-content-center mt-3">
                  <Image
                    className="mb-2"
                    preview={false}
                    width={Settings?.logoWidth}
                    src={logo2}
                    alt=""
                  />
                </div>
                <div className="d-flex justify-content-center mb-5x text-center">
                  <Title
                    level={5}
                    className="fw-bold text-wrap text-dark"
                    style={{ maxWidth: "90%" }}
                  >
                    Hillside Schools – Naalya
                  </Title>
                </div>
              </div>
            }
            style={{ backgroundColor: "#fafafa" }}
          >
            <Form
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              className="row-col"
            >
              <Form.Item
                className="username"
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  loading={loading}
                >
                  SIGN IN
                </Button>
              </Form.Item>
              <p className="font-semibold text-muted">
                Don't have an account?{" "}
                <Link to="/signup" className="text-dark font-bold">
                  Sign Up
                </Link>
              </p>
              <p className="font-semibold text-muted">
                Forgot Password?{" "}
                <Link to="/reset" className="text-dark font-bold">
                  Recover
                </Link>
              </p>
            </Form>
            {/* </Col> */}
            {/* </Row> */}
          </Card>
        </Content>
      </Layout>
    </>
  );
}
